module.exports = __webpack_public_path__ + "img/img_guide_delete_account_5.d180aea4.png";